<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Question Details</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <ng-container *ngIf="question_data.question">
    <h6>Question</h6>
    <p>{{ question_data.question }}</p>
  </ng-container>

  <ng-container *ngIf="question_data.status">
    <h6>Status</h6>
    <p>{{ question_data.status }}</p>
  </ng-container>

  <ng-container *ngIf="question_data.answers">
    <h6>Answers</h6>
    <p *ngFor="let answer of question_data.answers">
      {{ answer.answer_text }} -
      <b>{{ answer.answer_value ? 'Yes' : 'No' }}</b>
    </p>
  </ng-container>
</mat-dialog-content>
